<h1 class="card-title table-card-title">My Students</h1>
<div class="table-card" *ngIf="tableReady and isStudentConnected">
    <!-- <mat-form-field floatLabel="never">
        <input matInput placeholder="Search" (keyup)="applyFilter($event)">
    </mat-form-field> -->
    <form class="example-form">
        <mat-form-field class="example-full-width">
        <span matPrefix> </span>
        <input type="tel" matInput placeholder="Search" name= "search" [(ngModel)]= "searchedStudentName">
        <button matSuffix mat-button (click)="applyFilter()" class="btn-white"><mat-icon >search</mat-icon></button>
        </mat-form-field>
        </form>
    <table>
        <tr>
            <th *ngFor="let column of displayedColumns" class="font-title">
                {{column | translate}}
            </th>
        </tr>
        <tr *ngFor="let row of pageOfItems">
            <td class="arabic-story-name">
                <div [innerHTML]="safeAvatarSVG" class="avatar-image-container navbar-profile-dropdown-profile-image center"></div>
            </td>
            <td class="arabic-story-name">
                {{row.name}}
            </td>
            <td class="arabic-story-name">
                {{row.username}}
            </td>
            <td class="arabic-story-name">
                {{row.studentReadingLevel}}
            </td>
            <td>
                <button mat-icon-button (click)="callAssignStoryBook(row.username,row.studentReadingLevel,row.studentId)" class="center btn-white" title="Assign a book">
                    <mat-icon>assignment</mat-icon>
                </button>
            </td>
        </tr>
    </table>
    <div class="pag-card font-title">
        <jw-pagination [items]="allStudentsObjects" (changePage)="onChangePage($event)"></jw-pagination>
    </div>
</div>
<h4 *ngIf="!isStudentConnected" class="card-title table-card-title">There is no connected student record found</h4>